export default __webpack_public_path__ + "images/Q8.27b6cba.png";